import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { AREAS } from '../areas';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-content container">
        <div className="footer-section">
          <Link to="/" className="footer-logo" aria-label="ProClimb Solutions - home">
            <img src="/img/logo-128.webp" alt="ProClimb Solutions" width="140" height="52" loading="lazy" />
          </Link>
          <p style={{ color: '#aab3c2', marginBottom: '1rem' }}>
            Professional rope access services for high-rise buildings and complex structures across NSW.
          </p>
          <p style={{ color: '#aab3c2', fontSize: '0.9rem' }}>
            IRATA Level 3 Certified • Fully Insured • 10+ Years Experience
          </p>
        </div>

        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul className="footer-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/projects">Projects</Link></li>
            <li><Link to="/premium">Luxury Homes</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Services</h4>
          <ul className="footer-links">
            <li><Link to="/services/window-cleaning">Window Cleaning</Link></li>
            <li><Link to="/services/facade-cleaning">Facade Cleaning</Link></li>
            <li><Link to="/services/remedial">Remedial Work</Link></li>
            <li><Link to="/services/glazing">Glazing Services</Link></li>
            <li><Link to="/services/height-safety">Height Safety</Link></li>
            <li><Link to="/services/bird-control">Bird Control</Link></li>
            <li><Link to="/services/emergency">Emergency Response</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Legal</h4>
          <ul className="footer-links">
            <li><Link to="/terms-conditions">Terms & Conditions</Link></li>
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/disclaimer">Website Disclaimer</Link></li>
            <li><Link to="/safety-compliance">Safety Compliance</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Contact</h4>
          <ul className="footer-links">
            <li style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <Phone size={16} aria-hidden="true" />
              <a href="tel:0426920301">0426 920 301</a>
            </li>
            <li style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <Mail size={16} aria-hidden="true" />
              <a href="mailto:info@proclimbsolutions.com.au">info@proclimbsolutions.com.au</a>
            </li>
            <li style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem' }}>
              <MapPin size={16} style={{ marginTop: '5px', flexShrink: 0 }} aria-hidden="true" />
              <span style={{ color: '#aab3c2' }}>21 Mascot Drive, Eastlakes<br />Sydney, NSW 2018, Australia</span>
            </li>
          </ul>
        </div>
      </div>

      <nav className="footer-areas" aria-label="Service areas">
        <strong>Service areas:</strong>
        {AREAS.map((a) => (
          <Link key={a.slug} to={`/areas/${a.slug}`}>{a.name}</Link>
        ))}
      </nav>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} ProClimb Solutions. All rights reserved.</p>
        <p style={{ marginTop: '0.4rem' }}>Professional Rope Access • IRATA Certified • Sydney NSW</p>
      </div>
    </footer>
  );
};

export default Footer;
